import React from 'react'
import ReactSelect from 'react-select'
import R from 'ramda'
import { List } from 'immutable'

const pullValues = R.pluck('value')

/**
 * This extends react-select with valueLink support
 * https://github.com/JedWatson/react-select/issues/256
 */
class Select extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    valueLink: React.PropTypes.object,
    multi: React.PropTypes.bool,
    value: React.PropTypes.string
  }

  onChange (singleValue, multiValues) {
    // Dispatch to caller onChange if present
    if (this.props.onChange) {
      this.props.onChange(singleValue, multiValues)
    }

    if (this.props.valueLink) {
      // Multi select: grab values and send array of values to valueLink
      if (this.props.multi) {
        this.props.valueLink.requestChange(List(pullValues(multiValues)))
      }
      // Single select: send text value to valueLink
      else {
        this.props.valueLink.requestChange(singleValue)
      }
    }
  }

  render() {
    const { valueLink, ...other } = this.props
    let { value } = this.props

    value = value || (valueLink && valueLink.value) || ''
    if (value && value.toJS) value = value.toJS()

    return (
      <ReactSelect
        value={value}
        onChange={::this.onChange}
        allowSearchPersist
        {...other}
      />
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./modules/shared/components/select.js